import { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    nav: { home: "Home", about: "About", owa: "OWA Academy", contact: "Contact", cta: "Start Now" },
    hero: {
      title1: "From Zero to",
      title2: "Digital Empire",
      desc: "I didn't start this journey with a perfect plan. I started with questions, challenges, and the desire to build a better life. Today, I generate online income through digital systems and AI. If you're here, you probably want more too — more freedom, more income, more control.",
      cta: "Discover the System"
    },
    story: {
      overline: "My Story",
      title: "Meet Nihal Yayla",
      p1: "Hello, I'm Nihal. I didn't start this with a perfect plan. I started with questions, challenges, and the desire to build a better life.",
      p2: "Today, I generate online income through digital systems and AI. Many people start by creating additional income with this system. Some reach levels of 1,000 to 3,000 euros per month.",
      p3: "With the right system and consistency, this can grow over time. You don't have to be perfect. You just have to start.",
      p4: "Your journey starts here. I'm not here just to sell you something. I'm here to show you step by step how to begin this process."
    },
    owa_intro: {
      overline: "The Key to Digital Wealth",
      title: "What is OWA?",
      desc: "OWA Academy is more than just education — it's a boundless digital asset working for you. With Master Resell Rights (MRR), once you acquire the training, you don't just own it — you have the authority to sell it thousands of times under your own brand at 100% profit.",
      features: ["Ready business model — no need to create products from scratch", "Breaks language barriers — works in Turkish, German, English and Dutch", "No hidden costs — buy once, lifetime access and community support", "No experience needed — just a smartphone and internet"]
    },
    digital: {
      overline: "Digital Products",
      title: "What Are Digital Products?",
      desc: "Products that require no shipping, stock, or storage. Your knowledge and experience packaged into e-books, videos, and templates. Created once, sold thousands of times. 100% profit margin with no limits.",
      items: ["E-books and Guides", "Video Courses and Masterclasses", "Templates and Checklists", "Automation Systems"]
    },
    mrr: {
      overline: "MRR",
      title: "Master Resell Rights",
      desc: "The right to both use the product and sell it to others at 100% profit. Buy once, resell infinitely. Your customers can also resell — creating a win-win ecosystem."
    },
    cta_section: {
      title: "Your Empire Awaits",
      desc: "You don't need to show your face, spend huge capital, or have experience. Just the right system and strategy. The time to start is now.",
      btn: "Explore the System"
    },
    contact: {
      overline: "Contact",
      title: "Let's Connect",
      desc: "Ready to start your journey? Reach out to us.",
      office: "London Office",
      address: "71-75 Shelton Street, Covent Garden, London, WC2H 9JQ, United Kingdom"
    },
    footer: { rights: "All rights reserved.", company: "AUREM8 LTD | London, UK" }
  },
  tr: {
    nav: { home: "Ana Sayfa", about: "Hakk\u0131mda", owa: "OWA Akademi", contact: "\u0130leti\u015fim", cta: "Hemen Ba\u015fla" },
    hero: {
      title1: "S\u0131f\u0131rdan Dijital",
      title2: "\u0130mparatorlu\u011fa",
      desc: "Bu i\u015fe m\u00fckemmel bir planla ba\u015flamad\u0131m. Sorularla, zorluklarla ve daha iyi bir hayat kurma iste\u011fiyle ba\u015flad\u0131m. Bug\u00fcn dijital sistemler ve AI sayesinde online gelir olu\u015fturuyorum. E\u011fer buradaysan, muhtemelen sen de daha fazlas\u0131n\u0131 istiyorsun.",
      cta: "Sistemi Ke\u015ffet"
    },
    story: {
      overline: "Benim Hikayem",
      title: "Nihal Yayla",
      p1: "Merhaba, ben Nihal. Bu i\u015fe m\u00fckemmel bir planla ba\u015flamad\u0131m. Sorularla, zorluklarla ve daha iyi bir hayat kurma iste\u011fiyle ba\u015flad\u0131m.",
      p2: "Bug\u00fcn dijital sistemler ve AI sayesinde online gelir olu\u015fturuyorum. Bir\u00e7ok ki\u015fi bu sistemle ek gelir olu\u015fturarak ba\u015flar. Baz\u0131lar\u0131 ayl\u0131k 1.000 - 3.000 Euro seviyelerine ula\u015f\u0131r.",
      p3: "Do\u011fru sistem ve istikrarla bu zamanla b\u00fcy\u00fcyebilir. M\u00fckemmel olmak zorunda de\u011filsin. Sadece ba\u015flaman yeterli.",
      p4: "Senin yolculu\u011fun burada ba\u015fl\u0131yor. Sana sadece bir \u015fey satmak i\u00e7in burada de\u011filim. Sana bu s\u00fcrece nas\u0131l ba\u015flayaca\u011f\u0131n\u0131 ad\u0131m ad\u0131m g\u00f6stermek i\u00e7in burada y\u0131m."
    },
    owa_intro: {
      overline: "Dijital Servetin Anahtar\u0131",
      title: "OWA Nedir?",
      desc: "OWA Academy bir e\u011fitimden \u00f6te, ad\u0131n\u0131za \u00e7al\u0131\u015fan s\u0131n\u0131rlar\u0131 olmayan bir dijital varl\u0131kt\u0131r. Master Resell Rights (MRR) sayesinde e\u011fitimi bir kez edinince, ona sahip olmakla kalmaz, kendi markan\u0131z alt\u0131nda y\u00fczde y\u00fcz k\u00e2rla binlerce kez satma yetkisine sahip olursunuz.",
      features: ["Haz\u0131r i\u015f modeli \u2014 s\u0131f\u0131rdan \u00fcr\u00fcn \u00fcretme zahmeti yok", "Dil engelini a\u015fan g\u00fc\u00e7 \u2014 T\u00fcrk\u00e7e, Almanca, \u0130ngilizce ve Hollandaca", "Gizli maliyet yok \u2014 bir kez al\u0131n, \u00f6m\u00fcr boyu eri\u015fim ve topluluk deste\u011fi", "Deneyime ihtiyac\u0131n\u0131z yok \u2014 sadece bir ak\u0131ll\u0131 telefon ve internet yeter"]
    },
    digital: {
      overline: "Dijital \u00dcr\u00fcnler",
      title: "Dijital \u00dcr\u00fcnler Nedir?",
      desc: "Kargo, stok, depo gerektirmeyen \u00fcr\u00fcnler. Bilgi ve tecr\u00fcbenizin e-kitap, video, \u015fablon olarak paketlenmi\u015f hali. Bir kez \u00fcretilir, binlerce kez sat\u0131l\u0131r. K\u00e2r marj\u0131 y\u00fczde y\u00fcz, s\u0131n\u0131r yok.",
      items: ["E-Kitaplar ve Rehberler", "Video Kurslar ve Masterclass", "\u015eablonlar ve Kontrol Listeleri", "Otomasyon Sistemleri"]
    },
    mrr: {
      overline: "MRR",
      title: "Master Resell Rights",
      desc: "\u00dcr\u00fcn\u00fc hem kullanma hem de y\u00fczde y\u00fcz k\u00e2rla ba\u015fkas\u0131na satma hakk\u0131. Bir kez sat\u0131n al\u0131n, sonsuz kez sat\u0131n. M\u00fc\u015fterileriniz de satabilir \u2014 kazan-kazan ekosistemi."
    },
    cta_section: {
      title: "\u0130mparatorlu\u011funuz Sizi Bekliyor",
      desc: "Y\u00fcz\u00fcn\u00fcz\u00fc g\u00f6stermenize, devasa sermayeler harcaman\u0131za veya deneyiminiz olmas\u0131na gerek yok. Sadece do\u011fru sistem ve strateji. Ba\u015flamak i\u00e7in en do\u011fru zaman \u015fimdi.",
      btn: "Sistemi \u0130ncele"
    },
    contact: {
      overline: "\u0130leti\u015fim",
      title: "Ba\u011flant\u0131 Kural\u0131m",
      desc: "Yolculu\u011funuza ba\u015flamaya haz\u0131r m\u0131s\u0131n\u0131z? Bize ula\u015f\u0131n.",
      office: "Londra Ofisi",
      address: "71-75 Shelton Street, Covent Garden, London, WC2H 9JQ, United Kingdom"
    },
    footer: { rights: "T\u00fcm haklar\u0131 sakl\u0131d\u0131r.", company: "AUREM8 LTD | Londra, \u0130ngiltere" }
  },
  de: {
    nav: { home: "Startseite", about: "\u00dcber Mich", owa: "OWA Akademie", contact: "Kontakt", cta: "Jetzt Starten" },
    hero: {
      title1: "Von Null zum",
      title2: "Digitalen Imperium",
      desc: "Ich habe diese Reise nicht mit einem perfekten Plan begonnen. Ich begann mit Fragen, Herausforderungen und dem Wunsch, ein besseres Leben aufzubauen. Heute generiere ich Online-Einkommen durch digitale Systeme und KI.",
      cta: "System Entdecken"
    },
    story: {
      overline: "Meine Geschichte",
      title: "Nihal Yayla",
      p1: "Hallo, ich bin Nihal. Ich habe nicht mit einem perfekten Plan angefangen. Ich begann mit Fragen, Herausforderungen und dem Wunsch nach einem besseren Leben.",
      p2: "Heute generiere ich Online-Einkommen durch digitale Systeme und KI. Viele Menschen beginnen damit, mit diesem System ein zus\u00e4tzliches Einkommen aufzubauen. Manche erreichen 1.000 bis 3.000 Euro im Monat.",
      p3: "Mit dem richtigen System und Best\u00e4ndigkeit kann dies mit der Zeit wachsen. Du musst nicht perfekt sein. Du musst nur anfangen.",
      p4: "Deine Reise beginnt hier. Ich bin nicht hier, um dir etwas zu verkaufen. Ich bin hier, um dir Schritt f\u00fcr Schritt zu zeigen, wie du diesen Prozess starten kannst."
    },
    owa_intro: {
      overline: "Der Schl\u00fcssel zum Digitalen Wohlstand",
      title: "Was ist OWA?",
      desc: "OWA Academy ist mehr als Bildung \u2014 es ist ein grenzenloser digitaler Verm\u00f6genswert. Mit Master Resell Rights (MRR) k\u00f6nnen Sie das Training einmal erwerben und dann tausendmal unter Ihrer eigenen Marke mit 100 Prozent Gewinn verkaufen.",
      features: ["Fertiges Gesch\u00e4ftsmodell \u2014 keine eigene Produktentwicklung n\u00f6tig", "\u00dcberwindet Sprachbarrieren \u2014 T\u00fcrkisch, Deutsch, Englisch und Niederl\u00e4ndisch", "Keine versteckten Kosten \u2014 einmal kaufen, lebenslanger Zugang", "Keine Erfahrung n\u00f6tig \u2014 nur ein Smartphone und Internet"]
    },
    digital: {
      overline: "Digitale Produkte",
      title: "Was Sind Digitale Produkte?",
      desc: "Produkte ohne Versand, Lager oder Bestand. Ihr Wissen verpackt in E-Books, Videos und Vorlagen. Einmal erstellt, tausendfach verkauft. 100 Prozent Gewinnmarge ohne Grenzen.",
      items: ["E-Books und Guides", "Videokurse und Masterclasses", "Vorlagen und Checklisten", "Automatisierungssysteme"]
    },
    mrr: {
      overline: "MRR",
      title: "Master Resell Rights",
      desc: "Das Recht, das Produkt sowohl zu nutzen als auch mit 100 Prozent Gewinn weiterzuverkaufen. Einmal kaufen, unbegrenzt weiterverkaufen. Ihre Kunden k\u00f6nnen es auch weiterverkaufen."
    },
    cta_section: {
      title: "Ihr Imperium Wartet",
      desc: "Kein Gesicht zeigen, kein gro\u00dfes Kapital, keine Erfahrung n\u00f6tig. Nur das richtige System und die richtige Strategie. Die Zeit zu starten ist jetzt.",
      btn: "System Entdecken"
    },
    contact: {
      overline: "Kontakt",
      title: "Verbinden Wir Uns",
      desc: "Bereit, Ihre Reise zu beginnen? Kontaktieren Sie uns.",
      office: "London B\u00fcro",
      address: "71-75 Shelton Street, Covent Garden, London, WC2H 9JQ, United Kingdom"
    },
    footer: { rights: "Alle Rechte vorbehalten.", company: "AUREM8 LTD | London, UK" }
  }
};

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState('tr');
  const t = translations[lang] || translations.en;
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
